import {
  Component,
  ViewChild,
  EventEmitter,
  Input,
  OnInit,
} from "@angular/core";
import { ModalComponent } from "../../../components/modal/modal.component";
import { Subject } from "rxjs/Subject";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import * as _ from "underscore";
import { DataType } from "../../../models/data-type.model";
import { Tag } from "../../../models/tag.model";
import Utils from "../../../services/utils";
import { TagService } from "../../../services/tag.service";
import { DataService } from "../../../services/data.service";

@Component({
  selector: "lowy-select-patients",
  template: `
    <lowy-modal #modal>
      <div class="form">
        <div class="headline">Select Patients</div>
        <div class="subheading">Comma separated list of Patient IDs</div>
        <div class="seperator"></div>

        <label class="big"></label>

        <div class="full-mat-line">
          <textarea
            [(ngModel)]="patientIds"
            matInput
            placeholder="Patient IDs"
            matAutosizeMinRows="5"
          ></textarea>
        </div>
        <div class="seperator"></div>

        <div class="subheading">Include alternate Patient IDs?</div>
        <mat-checkbox [(ngModel)]="patId2"
          >A Number / Patient ID 2</mat-checkbox
        >
        <mat-checkbox [(ngModel)]="patId3">Patient ID 3</mat-checkbox>
        <mat-checkbox [(ngModel)]="patId4">Patient ID 4</mat-checkbox>

        <div class="seperator"></div>
        <div class="button-row">
          <span (click)="cancel()">cancel</span>
          <span (click)="clear()">clear</span>
          <button mat-button class="lowy-btn-std" (click)="save()">save</button>
        </div>
      </div>
    </lowy-modal>
  `,
  styles: [
    `
      .seperator {
        margin-bottom: 15px;
      }
    `,
  ],
})
export class SelectPatientsComponent {
  @ViewChild("modal") modal: ModalComponent;

  public patientIds: string;

  public savePatientIdsEventEmitter: Subject<{
    patientIds: string[];
    alternateIds: {
      patId2: boolean;
      patId3: boolean;
      patId4: boolean;
    };
  }>;

  public patId2 = false;
  public patId3 = false;
  public patId4 = false;

  constructor() {
    this.savePatientIdsEventEmitter = new Subject();
  }

  public open(patientIds?: string[]) {
    this.modal.open();
    if (patientIds) {
      this.patientIds = patientIds.join(", ");
    } else {
      this.patientIds = "";
    }
  }

  save() {
    let patientIdArr;
    if (this.patientIds && this.patientIds.length > 0) {
      // save patientIds as array, allow comma separated or newline separated
      patientIdArr = _.uniq(
        this.patientIds
          .split(/[\s,]+/)
          .map((str) => str.trim())
          .filter((str) => str !== "")
      );
    }
    this.savePatientIdsEventEmitter.next({
      patientIds: patientIdArr ? patientIdArr : [],
      alternateIds: {
        patId2: this.patId2,
        patId3: this.patId3,
        patId4: this.patId4,
      },
    });
    this.modal.close();
  }

  cancel() {
    this.modal.close();
  }

  clear() {
    this.patientIds = "";
  }
}



// WEBPACK FOOTER //
// ./src/app/home/search/search-modals/select-patients-modal.component.ts